var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircledMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_0_3",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_0_3",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB/ElEQVR4nO3cSU7DMBSA4a7gHjYrhlvgBxfIHRpHOQpVQQyXAS5BOQjDsqjIpAtQ26geaMD+PykSEosXxeAk9BejEQAAAAAAALClRp2e1Foua2VmtZL37jAzq2U6VuY49YVsMp+3tfbgfL/W5rbW5sNqWaw7vr6n5KY6rPaYl/jiW2UeN134NcdDzCK0mc/zZrW58zi57lByzbxke+LmbWfzYeZWnx0xL5K7Iflf/OU9QcmEeZGsMs+hC2C1PDEvUq3kLXgBlHll3oALUCvzwrxIbEGSdIv1XwAt0/AtSC6YF8m9fnePlLt5DB1nPi+I+/NCwA34inmJuNdu9/q99c1Xy33Mq3qV+bzwk1Ry3f/raubuJz/FyVWZzwvm9j33huueANwj6vIx1X09+Y090WY+DwAAAAAAACi21WxoQ8toUb1PLudWs6UNLatF9UIbKsN+KE8bKknbV2+EWTJsmEUbKknb150uAG1oAmxBMuwWRBsqSdtXb7m3mmPa0PJaVG+5t5oVbegq2tBCW01LGwoAAAAAAIC/IvdWs6EN7dCGFtRqtrShP9GGfkMbKkkjAG+0odITntGGLmJDqV2HZ95oQ6UvTaENtf/s/5R6ow2VYbcg2lDp2YJoQxexj4W0oWvQhhbWala0oatoQwttNS1tKAAAAAAAAEZpfAI9l3xNW98fQQAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircledMenu);
export default __webpack_public_path__ + "static/media/Circled Menu.3bcad2adaff81c855cbb55888c1562da.svg";
export { ForwardRef as ReactComponent };